export default __webpack_public_path__ + "static/media/placeholder_private03-jp-web.03c153f2.png";